import { render, staticRenderFns } from "./TaxIndex.vue?vue&type=template&id=5ac7dd0f&scoped=true&"
import script from "./TaxIndex.vue?vue&type=script&lang=js&"
export * from "./TaxIndex.vue?vue&type=script&lang=js&"
import style0 from "./TaxIndex.vue?vue&type=style&index=0&id=5ac7dd0f&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ac7dd0f",
  null
  
)

export default component.exports